import {
  HeadingTitle,
  SubHeadingTitle
} from "../../../components/shared/index";
import styles from "./aboutus.module.css";
import { PiBriefcaseLight } from "react-icons/pi";
import { LiaAwardSolid } from "react-icons/lia";
import { IoBulbOutline } from "react-icons/io5";
import { LiaSmileBeam } from "react-icons/lia";
const Stats = () => {
  return (
    <div className={styles.stats}>
      <div className={styles.statItem}>
        {/* <PiBriefcaseLight className={styles.icon} />  */}
        <HeadingTitle text="60 K+" style={styles.statHeading} />
        <SubHeadingTitle
          subTitle="Store Worldwide"
          style={styles.statSubHeading}
        />
      </div>
      <div className={styles.statItem}>
        {/* <LiaAwardSolid className={styles.icon} /> */}
        <HeadingTitle text="86 K+" style={styles.statHeading} />
        <SubHeadingTitle
          subTitle="Active Salesman"
          style={styles.statSubHeading}
        />
      </div>
      <div className={styles.statItem}>
        {/* <IoBulbOutline className={styles.icon} /> */}
        <HeadingTitle text="105 M+" style={styles.statHeading} />
        <SubHeadingTitle
        subTitle="Grocery Products"
          style={styles.statSubHeading}
        />
      </div>
      <div className={styles.statItem}>
        {/* <LiaSmileBeam className={styles.icon} />  */}
        <HeadingTitle text="60 M+" style={styles.statHeading} />
        <SubHeadingTitle
          subTitle="Happy Customer"
          style={styles.statSubHeading}
        />
      </div>
    </div>
  );
};
export default Stats;